import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core'
import { MultiFactorInfo, PhoneMultiFactorInfo } from '@angular/fire/auth'
import { MatIcon } from '@angular/material/icon'
import { Title } from '@angular/platform-browser'
import { Router } from '@angular/router'

import { ButtonComponent } from '../../components/button/button.component'
import { AuthService } from '../../services/auth.service'
import { getTitle } from '../../util/accessibility'
import { MfaService } from '../../services/mfa.service'

@Component({
  selector: 'app-mfa-verify-select-page',
  standalone: true,
  imports: [MatIcon, ButtonComponent],
  templateUrl: './mfa-verify-select-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mfa-verify-select-page.component.scss',
})
export class MfaVerifySelectPageComponent implements OnInit {
  hints: MultiFactorInfo[] = []
  busy = false
  errorMessage = ''
  constructor(
    private authService: AuthService,
    private mfa: MfaService,
    private router: Router,
    title: Title,
  ) {
    title.setTitle(getTitle('二要素認証の方法を選択'))
  }
  async backToLogin(): Promise<void> {
    await this.authService.signOutPreservingReturnUrl()
    this.authService.redirectToLogin()
  }
  ngOnInit(): void {
    const resolver = this.authService.getLoginResult()?.resolver
    if (!resolver) {
      this.router.navigate(['/login'])
      return
    }
    this.hints = resolver.hints
  }
  phoneNumber(hint: MultiFactorInfo): string {
    return (hint as PhoneMultiFactorInfo).phoneNumber
  }
  async select(uid: string): Promise<void> {
    if (this.busy) return
    const result = this.authService.getLoginResult()
    if (!result?.resolver) {
      await this.router.navigate(['/login'])
      return
    }
    const hint = result.resolver.hints.find((factor) => factor.uid === uid)
    if (!hint) return
    this.busy = true
    this.errorMessage = ''
    try {
      this.authService.setLoginResult({ ...result, factorUid: uid })
      if (hint.factorId === 'phone') {
        const phoneHint = hint as PhoneMultiFactorInfo
        this.authService.setPhoneNumber(phoneHint.phoneNumber)
        this.authService.setVerificationId(
          await this.mfa.sendSmsCode(result.resolver, phoneHint),
        )
        await this.router.navigate(['/auth/phone-setup/verify'])
      } else if (hint.factorId === 'totp') {
        await this.router.navigate(['/auth/totp-verify'])
      }
    } catch (error) {
      const code = (error as { code?: string }).code
      this.errorMessage =
        code === 'auth/too-many-requests'
          ? '試行回数が多すぎます。しばらく待ってから再度お試しください。'
          : '認証コードを送信できませんでした。再度お試しください。'
    } finally {
      this.busy = false
    }
  }
}
